import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './DuperbrowsePaddles';
import { moveNext, movePrev } from '../redux/actionCreators';
import {
  getDuperbrowseNavigation,
  getIsDuperbrowseActive,
  getIsKeyboardDuperbrowseAllowed,
  getPreloadingEnabled,
} from '../redux/selectors';
import { DuperbrowseStoreSlice } from '../redux/types';

type StateProps = Pick<
  Props,
  | 'navigation'
  | 'enableKeyboardNavigation'
  | 'preloadEnabled'
  | 'isDuperbrowseActive'
>;
type DispatchProps = Pick<Props, 'moveNext' | 'movePrev'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  DuperbrowseStoreSlice
> = (state, ownProps) => ({
  navigation: getDuperbrowseNavigation(state),
  isDuperbrowseActive: getIsDuperbrowseActive(state),
  enableKeyboardNavigation:
    !ownProps.isInZoomModal && getIsKeyboardDuperbrowseAllowed(state),
  preloadEnabled: getPreloadingEnabled(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  moveNext,
  movePrev,
};

export default connect(mapStateToProps, mapDispatchToProps);
